import React, { useState } from 'react';
import './index.scss';
import DiscardIssueModal from '@/components/DiscardIssueModal';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { CockpitMode, IssueStatus } from '@/utils/type';
import { getClstag } from '@/utils/util';

const DiscardIssue = (props: {
  vehicleName: string;
  LC_BUTTON_L3?: boolean;
  closeDropdown: () => void;
}) => {
  const { vehicleName, LC_BUTTON_L3 } = props;
  const [open, setOpen] = useState(false);
  const { cockpitMode } = useSelector((state: RootState) => state.newCommon);
  const { list } = useSelector((state: RootState) => state.issue);
  const { issueStatus, issueNumber } =
    list?.find((workOrder: any) => {
      return workOrder.vehicleName === vehicleName;
    }) || {};
  const usable =
    (issueStatus === IssueStatus.PROCESS ||
      issueStatus === IssueStatus.ON_HOLD) &&
    [CockpitMode.LISTENING_MODE, CockpitMode.WATCH_CAR_MODE].includes(
      cockpitMode
    );
  return (
    <>
      <button
        className="issue-command-btn"
        disabled={!issueNumber || !usable}
        onClick={() => {
          if (!issueNumber) {
            return;
          }
          usable && setOpen(true);
          props.closeDropdown();
        }}
        clstag={usable ? getClstag(cockpitMode, 'SinglePage_DiscardIssue') : ''}
      >
        抛单
      </button>
      <DiscardIssueModal
        open={open}
        setOpen={setOpen}
        vehicleName={vehicleName}
        LC_BUTTON_L3={LC_BUTTON_L3}
        issueNumber={issueNumber}
        issueStatus={issueStatus}
      />
    </>
  );
};

export default React.memo(DiscardIssue);
